export { default as useThemeObserver } from '../use-theme-observer';
